export const CelebrationType = {
    CONFETTI: 'confetti',
    FIREWORKS: 'fireworks',
    STARS: 'stars',
    TROPHY: 'trophy',
    VOLLEYBALL_RAIN: 'volleyballRain',
    PARTY_POPPERS: 'partyPoppers'
};

export const CelebrationTint = {
    RED: 'red',
    BLUE: 'blue',
    RAINBOW: 'rainbow'
};

export const CELEBRATION_COOLDOWN_MS = 5000;
export const CELEBRATION_DURATION_MS = 6500;

export const celebrationMessages = [
    "LET'S GO!",
    'EPIC POINT!',
    'VOLLEYBALL LEGEND!',
    'MVP MOMENT!',
    'ABSOLUTE CINEMA',
    'WHAT A PLAY!',
    'UNSTOPPABLE!',
    'PARTY TIME!',
    'BOOM!',
    'VICTORY DANCE ACTIVATED'
];

const celebrationTypes = Object.values(CelebrationType);
const celebrationTints = Object.values(CelebrationTint);

export function pickRandomItem(items, random = Math.random) {
    return items[Math.floor(random() * items.length) % items.length];
}

export function createCelebration(random = Math.random) {
    return {
        id: `${Date.now()}-${Math.round(random() * 1000000)}`,
        type: pickRandomItem(celebrationTypes, random),
        message: pickRandomItem(celebrationMessages, random),
        tint: pickRandomItem(celebrationTints, random)
    };
}

export function shouldTriggerCelebration({
    isActive,
    lastTriggeredAt,
    now,
    cooldownMs = CELEBRATION_COOLDOWN_MS
}) {
    if (isActive) {
        return false;
    }

    if (lastTriggeredAt !== null && now - lastTriggeredAt < cooldownMs) {
        return false;
    }

    return true;
}

export function getMotionStrength(event) {
    const acceleration = event.acceleration || event.accelerationIncludingGravity;
    if (!acceleration) {
        return 0;
    }

    const x = acceleration.x || 0;
    const y = acceleration.y || 0;
    const z = acceleration.z || 0;
    const magnitude = Math.sqrt((x * x) + (y * y) + (z * z));

    if (event.acceleration) {
        return magnitude;
    }

    return Math.max(0, magnitude - 9.81);
}

export function isStrongShake(event, threshold = 18) {
    return getMotionStrength(event) >= threshold;
}

export function getMotionSample(event) {
    const acceleration = event.accelerationIncludingGravity || event.acceleration;
    if (!acceleration) {
        return null;
    }

    return {
        x: acceleration.x || 0,
        y: acceleration.y || 0,
        z: acceleration.z || 0
    };
}

export function createShakeDetector({
    deltaThreshold = 18,
    directThreshold = 18,
    sampleCooldownMs = 220,
    now = () => Date.now()
} = {}) {
    let previousSample = null;
    let lastDetectedAt = 0;

    return {
        reset() {
            previousSample = null;
            lastDetectedAt = 0;
        },
        isShake(event) {
            const sample = getMotionSample(event);
            if (!sample) {
                return false;
            }

            const currentTime = now();
            if (currentTime - lastDetectedAt < sampleCooldownMs) {
                previousSample = sample;
                return false;
            }

            const directStrength = getMotionStrength(event);
            if (directStrength >= directThreshold) {
                previousSample = sample;
                lastDetectedAt = currentTime;
                return true;
            }

            if (!previousSample) {
                previousSample = sample;
                return false;
            }

            const delta = Math.abs(sample.x - previousSample.x)
                + Math.abs(sample.y - previousSample.y)
                + Math.abs(sample.z - previousSample.z);

            previousSample = sample;

            if (delta < deltaThreshold) {
                return false;
            }

            lastDetectedAt = currentTime;
            return true;
        }
    };
}
